import { Component, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { AsyncPipe } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoginService } from '../services/login.service';
import { FabricDataService } from '../fabric-data.service';
import { Observable, combineLatest, map, filter, startWith } from 'rxjs';
import { DASHBOARD_CONFIGS } from '../models/dashboard.config';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    AsyncPipe
  ],
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  #loginService = inject(LoginService);
  #router = inject(Router);
  #fabricDataService = inject(FabricDataService);

  logo = environment.logo;
  showPoweredBy = environment.whiteLabel;
  userName = ''; // Placeholder for user name
  userEmail = ''; // Placeholder for user email

  isUserLoggedIn$: Observable<boolean>;
  availableDashboards$!: Observable<Array<{ route: string; label: string; isActive: boolean }>>;

  constructor() {
    this.isUserLoggedIn$ = this.#loginService.isLoggedIn();
    this.isUserLoggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.userName = this.#loginService.loginUser?.name;
        this.userEmail = this.#loginService.loginUser?.email;
      }
    });

    // Set up dashboard switching logic
    const currentRoute$ = this.#router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.#router.url),
      startWith(this.#router.url) // Emit the current URL immediately
    );

    // Set up available dashboards list
    this.availableDashboards$ = combineLatest([
      currentRoute$,
      this.#fabricDataService.getDashboardPermissions()
    ]).pipe(
      map(([currentUrl, permissions]) => {
        const currentRoute = currentUrl.split('?')[0];

        return DASHBOARD_CONFIGS
          .filter(dashboard => permissions.includes(dashboard.permission))
          .map(dashboard => ({
            route: dashboard.route,
            label: dashboard.label,
            isActive: currentRoute === dashboard.route
          }));
      })
    );
  }

  onLogout(): void {
    // Placeholder for logout functionality
    console.log('Logout clicked');
    this.#loginService.logout();
  }

  onSwitchDashboard(targetRoute: string): void {
    this.#router.navigate([targetRoute]);
  }
}
